/**
 * Add identifiers for:
 * - first block
 * - last block
 */
(() => {
    let blocks = document.querySelector('.blocks');

    if (!blocks) {
        return;
    }

    for (let i = 0; i < blocks.childNodes.length; i++) {
        if (
            blocks.childNodes[i].nodeType !== 3 &&
            typeof blocks.childNodes[i].classList !== 'undefined'
        ) {
            blocks.childNodes[i].classList.add('-first-block');
            break;
        }
    }
    for (let i = blocks.childNodes.length - 1; i >= 0; i--) {
        if (
            blocks.childNodes[i].nodeType !== 3 &&
            typeof blocks.childNodes[i].classList !== 'undefined'
        ) {
            blocks.childNodes[i].classList.add('-last-block');
            break;
        }
    }
})();
